import {BaseGameTemplateAnimationSetModel} from "./base-game-template-animation-set-model";
import {AnimationLogoCardEventRequestParams} from "../animation-logo-card-event-request-params";

export class RegularGameEventTemplateAnimationSetModel extends BaseGameTemplateAnimationSetModel {
  get eventLogo(): AnimationLogoCardEventRequestParams {
    return new AnimationLogoCardEventRequestParams(this.id, this.isHomeCompetitor);
  }
}
